import OSS from 'ali-oss';
import {ossSts} from "@/api/third/aliyun";
// import {storage} from "@/utils/index";

export default {
    client: async function (bucket) {
        // let data = storage.getSession('sts');
        // if (!data) {
        //     data = (await ossSts()).data;
        //     storage.setSession('sts', data);
        // }
        let data = (await ossSts()).data;
        return new OSS({
            region: 'oss-cn-shenzhen',
            //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
            stsToken: data.securityToken,
            bucket: bucket || 'static-maker-fac',
            secure: true
        });
    }
};
